<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Documentation/Defining_an_Editor/Boolean_Projections';
    let nextLink= '/Documentation/Defining_an_Editor/String_Projections';
    
    import Note from "$lib/notes/Note.svelte";
    import Figure from "$lib/figures/Figure.svelte";
</script>

<PrevNextSection {prevLink} {nextLink} />



<SectionComponent tag="h1" 
  id="number-projections-1"
  bind:intersecting={visibleById["number-projections-1"]}
  onIntersectChange={(visible) => setVisible("number-projections-1", visible)}
>Number Projections</SectionComponent>
<p>Freon offers a slider control displaying numeric values.
You can set a default for the display of a number value in the <a
  href="/Documentation/Defining_an_Editor/Global_Projections"
><code>global</code></a> section of the
default editor. However, a slider is rarely the preferred default display option. </p>
<SectionComponent tag="h2" 
  id="sliders-2"
  bind:intersecting={visibleById["sliders-2"]}
  onIntersectChange={(visible) => setVisible("sliders-2", visible)}
>Sliders</SectionComponent>
<p>The slider control is
indicated by adding the keyword <code>slider</code> to the property projection. When hovering over the
slider button the actual property value is shown.</p>
<p>For the sake of the example, we have added two number properties to the concept <code>BaseProduct</code>.</p>
<pre class="language-freon"><code class="language-freon">// Insurance/src/defs/language-main.ast#L34-L36

range: number;
nrOfUse: number;
// The previoud two properties are present to show the different options for displaying numbers.</code></pre>
<p>The added properties are displayed like this.</p>
<pre class="language-freon"><code class="language-freon">// Insurance/src/defs/editor-main-controls.edit#L12-L13

expected nr of use: $&#123;self.nrOfUse&#125;
range: $&#123;self.range slider&#125;</code></pre>
<p>Which results in the following.</p>
<Figure
imageName={'documentation/Documentation-Number-Projections-screenshot1.png'}
caption={'A number slider control'}
figureNumber={1}
/>


<PrevNextSection {prevLink} {nextLink} />